import { Button, Text } from "@fluentui/react-components";
import { DownloadDocumentIcon } from "@fluentui/react-icons-mdl2";
import { useFormikContext } from "formik";
import { useAtomValue } from "jotai";
import { extractFileNameFromUrl, openLinkInNewTab } from "library/utils";
import { useTranslation } from "react-i18next";
import { selectedClientAtom } from "store";
import styled from "styled-components";

import { Grid } from "components/styled";
import { UploadFile } from "components/UploadFile/UploadFile";

type Props = {
  isSalaryDeductionPaymentType?: boolean;
};

export function SalaryDeductionConsent({ isSalaryDeductionPaymentType }: Props) {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext<FormData>();
  const client = useAtomValue(selectedClientAtom);

  const salaryDeductionTemplateOnClient = client?.salaryDeductionConsentDocumentPath;

  // const selectedInsurerConsentType = values["insurerConsentType"];

  // if (!selectedInsurerConsentType) {
  //   return null;
  // }

  return (
    <Container>
      <Text weight="semibold" size={400}>
        {t("hbh.salaryDeductionConsent.label")}
      </Text>

      <Grid gridColumns={1}>
        {salaryDeductionTemplateOnClient && (
          <Button
            style={{
              justifyContent: "flex-start",
              gap: "5px",
            }}
            appearance="transparent"
            icon={<DownloadDocumentIcon />}
            onClick={() => {
              openLinkInNewTab(salaryDeductionTemplateOnClient);
            }}
          >
            {extractFileNameFromUrl(salaryDeductionTemplateOnClient)}{" "}
            {`- ${t("hbh.download.label")}`}
          </Button>
        )}
        {isSalaryDeductionPaymentType ? (
          <UploadFile
            setFieldValue={setFieldValue}
            fieldName="salaryDeductionSignedDoc"
            // label={t("hbh.uploadSignedSalaryDeductionDoc.label")}
            label={""}
          />
        ) : null}
      </Grid>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid ${({ theme }) => theme.palette.neutralLight};
  border-radius: 2px;
  padding: 10px;
  margin: 10px 0px;
`;
